import React from 'react';

export default function SegmentMonetizationCard() {
  return (
    <article className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm dark:border-slate-800 dark:bg-[#101922]">
      <h4 className="text-sm font-black text-slate-900 dark:text-white">Segment Monetization</h4>
      <p className="mt-2 text-xs text-slate-500 dark:text-slate-400">Reach + intent + conversion + confidence görünümü için hazırlık kartı.</p>
    </article>
  );
}
